export type InnovEnergyUser = {
  email: string;
  userType: UserType;
  id: number;
  information: string;
  language: string;
  name: string;
  parentId: number;
  password: number;
  type: string;
  folderIds?: number[];
  mustResetPassword: boolean;
};

export interface I_UserWithInheritedAccess {
  folderId: number;
  folderName: string;
  user: InnovEnergyUser;
}

export enum UserType {
  client = 0,
  partner,
  admin
}
